import React from 'react';
import { Icon } from '@chakra-ui/react';

export const RewardEmbellishment = (props): JSX.Element => (
  <Icon fill="none" {...props} viewBox="0 0 24 68">
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0001 25.8833L15.3012 23.1446L16.406 18.9999L19.1447 22.3011L23.2893 23.4058L19.9882 26.1446L18.8834 30.2892L16.1446 26.9881L12.0001 25.8833Z"
        fill={props.currentColor}
      />
      <path
        opacity="0.4"
        d="M0.0124512 12.8235L1.75958 12.4775L2.98348 11.1836L3.3294 12.9307L4.62334 14.1546L2.87619 14.5006L1.65231 15.7945L1.30637 14.0473L0.0124512 12.8235Z"
        fill={props.currentColor}
      />
      <path
        opacity="0.7"
        d="M10.5803 55.6306L10.9193 52.1196L9.16204 49.0612L12.673 49.4001L15.7315 47.6429L15.3925 51.1539L17.1498 54.2123L13.6388 53.8734L10.5803 55.6306Z"
        fill={props.currentColor}
      />
      <circle opacity="0.6" cx="22.6489" cy="6.75749" r="1.35149" fill={props.currentColor} />
      <circle opacity="0.6" cx="1" cy="67" r="1" fill={props.currentColor} />
      <circle opacity="0.8" cx="7.7817" cy="0.675744" r="0.675744" fill={props.currentColor} />
      <circle cx="3.69988" cy="36.7873" r="1.35149" fill={props.currentColor} />
    </svg>
  </Icon>
);
